exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2QZLZ5seaRQ499CoBlGHyz{width:275px;height:auto;-ms-flex-item-align:center;align-self:center}", ""]);
// Exports
exports.locals = {
	"n-freImage": "_2QZLZ5seaRQ499CoBlGHyz"
};